export const metatagipotwierdzenieError = {
  Page: {
    "meta-tagi": {
      Title:
        "SkiOne.pl ••• błąd wstępnej rezerwacji klienta dla SkiOne.pl",
      Description:
        "SkiOne.pl ••• znajdź najlepsze oferty wczasów SkiOne.pl, last minute SkiOne.pl, tanie wakacje SkiOne.pl, zestawienie wycieczek SkiOne.pl, rezerwuj hotel SkiOne.pl, all inclusive",
      Keywords: []
    }
  }
};
